if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initialize);
} else {
	initialize();
}

/*
* Script to handle freeform forms.
*/
function initialize () {
    const forms = document.querySelectorAll('form[data-freeform]');

    forms.forEach((form) => {
        const hiddenWebsiteUrlField = form.querySelector('input[name="websiteUrl"]');

        if (hiddenWebsiteUrlField) {
            hiddenWebsiteUrlField.value = window.location.href;
        }

        const resetButton = form.querySelector('.freeform-reset-form');
        if (resetButton) {
            resetButton.addEventListener('click', function(e) {
                const outerContainer = form.closest('.freeform-outer-container');
                outerContainer.querySelectorAll(".freeform-row, .freeform-title, .freeform-text").forEach((row) => {
                    row.classList.remove("invisible");
                });
                form.querySelector(".freeform-ajax-success").classList.remove("active");
            });
        }

        // Do something on a successful ajax submit
        form.addEventListener('freeform-ajax-success', function(event) {
            event.preventDefault();

            if (event.response.finished) {
                const outerContainer = form.closest('.freeform-outer-container');
                outerContainer.querySelectorAll(".freeform-row, .freeform-title, .freeform-text").forEach((row) => {
                    row.classList.add("invisible");
                });
                form.querySelector(".freeform-ajax-success").classList.add("active");
            }
        })
    });
}